import { create, update } from 'common/api/financierProduct';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import {
    SAVE_PRODUCT,
    SAVE_PRODUCT_FAILURE,
    SAVE_PRODUCT_SUCCESS,
} from '../actionTypes';
import getConfig from '../partners/getConfig';
import { actions } from '../reducer';

import resetForm from './resetForm';
import toggleModalProduct from './toggleModalProduct';

export default (values, callback) => (dispatch) => {
    const { financier, id } = values;

    if (!financier) return;

    const { buildPayload } = getConfig(financier);
    const newValues = buildPayload(values);

    const save = id ? () => update(newValues, id) : () => create(newValues);

    dispatch(actions[SAVE_PRODUCT]());

    save()
        .then(() => {
            dispatch(actions[SAVE_PRODUCT_SUCCESS]());
            dispatch(resetForm());
            dispatch(toggleModalProduct(false));
            showToast();
            if (callback) callback();
        })
        .catch((error) => {
            dispatch(
                actions[SAVE_PRODUCT_FAILURE](error?.response?.data?.errors),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
